enum Key {
  Alt = 'Alt',
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  End = 'End',
  Enter = 'Enter',
  Escape = 'Escape',
  Delete = 'Delete',
  Home = 'Home',
  PageDown = 'PageDown',
  PageUp = 'PageUp',
  Shift = 'Shift',
  Space = ' ',
  Tab = 'Tab',
}

export default Key;
